var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0004 7.87427C17.5512 8.02541 17.9849 8.47072 18.1321 9.03622C18.3996 10.0611 18.3996 12.1996 18.3996 12.1996C18.3996 12.1996 18.3996 14.338 18.1321 15.363C17.9849 15.9285 17.5512 16.3738 17.0004 16.525C16.0023 16.7996 11.9996 16.7996 11.9996 16.7996C11.9996 16.7996 7.99692 16.7996 6.99874 16.525C6.44797 16.3738 6.01423 15.9285 5.86703 15.363C5.59961 14.338 5.59961 12.1996 5.59961 12.1996C5.59961 12.1996 5.59961 10.0611 5.86703 9.03622C6.01423 8.47072 6.44797 8.02541 6.99874 7.87427C7.99692 7.59961 11.9996 7.59961 11.9996 7.59961C11.9996 7.59961 16.0023 7.59961 17.0004 7.87427ZM10.7996 10.3996V14.3996L13.9996 12.3996L10.7996 10.3996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial4);
export default __webpack_public_path__ + "static/media/Social4.f1e01bcc780ab706af87ad9c3ef5bf66.svg";
export { ForwardRef as ReactComponent };